import N8nRecycleScroller from './RecycleScroller.vue';

export default N8nRecycleScroller;
